function Events({ children }: any) {
  return <>{children}</>;
}

export default Events;
